module.exports = __webpack_public_path__ + "static/our-story-about-us-9a9820e550641f8aab29fd52755e0f99.png";